export class BranchCampaignsMiniEntity {
 id?: number;
 name?: string | null;
}
